<template>
  <div class="main">
    <div>
      <router-view/>
    </div>
    <div>
      <CallFullScreen />
    </div>
  </div>
</template>
<script>
import { blacktel } from './config/pluginInit'
import CallFullScreen from './views/Pages/CallFullScreen'

export default {
  name: 'App',
  components: {
    CallFullScreen
  },
  data () {return {}},
  mounted () {
    blacktel.mainIndex()
  }
}
</script>
<style lang="scss">
  // @import "assets/scss/style.scss";
  @import '~node-snackbar/src/sass/snackbar.sass';
  @import "assets/stylesheets/style.css";
  // @import "assets/stylesheets/style-min.css";
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(155, 171, 197, 0.1);
  }
  .snackbar-container {
    padding: 24px;
    border-radius: 1.25rem;
    box-shadow: 0px 2px 18px 0 rgb(0 0 0 / 30%);
	}

	.snackbar-container p {
    color: #fff !important;
    font-weight: 400 !important;
    font-family: "Raleway", sans-serif;
	}
	.snackbar-container .action {
    font-family: "Raleway", sans-serif;
    color: rgb(244 246 251) !important;
    font-size: 10px;
	}
  .mt-5 {
    margin-top: 5rem;
  }
  .vue-tel-input {
    height: 48px !important;
    border-color: #cfd8dc !important;
    border-radius: 10px !important;
  }
  .vti__input{
    border-left: 1px solid #cfd8dc !important;
    border-color: transparent !important;
    border-radius:0px 10px 10px 0px!important;
  }
  .vti__dropdown{
    border-radius: 10px 0px 0px 10px!important;
  }
  .dark-theme .vue-tel-input{
    border-color: #424242 !important;
    &:hover {

    }
  }
  .dark-theme .vti__dropdown{
      background-color: #262a2d !important;
    &:hover {
      background-color: #262a2d !important;
    }
  }
  .dark-theme .vti__dropdown-list{
    background-color: #262a2d !important;
    border-color: #16191c !important;
  }
  .dark-theme .highlighted{
    background-color: #5a668b !important;
  }
</style>
